module.exports = __webpack_public_path__ + "img/chart-mixed.d235f6c6.svg";